import React from 'react';
import {
  Box,
  List,
  ListItemText,
  Divider,
  Tooltip,
  ListItemIcon,
  Drawer as MuiDrawer,
  ListItemButton,
} from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SettingsIcon from '@mui/icons-material/Settings';
import AudiotrackIcon from '@mui/icons-material/Audiotrack';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

const Drawer: React.FC<DrawerProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();

  const handleNavigate = (path: string) => {
    navigate(path);
    onClose();
  };

  const handleProfileClick = () => {
    const env = process.env.NODE_ENV;
    let targetUrl = '';
    if (env === 'development') {
      targetUrl = `http://localhost:3000`;
    } else {
      targetUrl = `https://connect.publisol.com.br`;
    }
    window.open(targetUrl, '_blank');
  };

  const handleSignOut = () => {
    signOut();
    navigate('/login');
  };

  return (
    <MuiDrawer anchor="left" open={isOpen} onClose={onClose}>
      <Box sx={{ width: 250 }} role="presentation" onClick={onClose} onKeyDown={onClose}>
        <List>
          <Tooltip title="Dashboard" placement="right">
            <ListItemButton onClick={() => handleNavigate('/dashboard')}>
              <ListItemIcon>
                <DashboardIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="Dashboard" />
            </ListItemButton>
          </Tooltip>

          <Tooltip title="Configurações Synthesis" placement="right">
            <ListItemButton onClick={() => handleNavigate('/synthesis/configurations')}>
              <ListItemIcon>
                <SettingsIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="Configurações Synthesis" />
            </ListItemButton>
          </Tooltip>

          <Tooltip title="Upload de Áudio" placement="right">
            <ListItemButton onClick={() => handleNavigate('/audio-upload')}>
              <ListItemIcon>
                <AudiotrackIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="Upload de Áudio" />
            </ListItemButton>
          </Tooltip>

          <Divider />

          <Tooltip title="Gerenciar seu perfil." placement="right">
            <ListItemButton onClick={handleProfileClick}>
              <ListItemIcon>
                <AccountCircle color="primary" />
              </ListItemIcon>
              <ListItemText primary="Perfil" />
            </ListItemButton>
          </Tooltip>
          <Tooltip title="Desconectar sua conta Publisol." placement="right">
            <ListItemButton onClick={handleSignOut}>
              <ListItemIcon>
                <LogoutIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="Desconectar" />
            </ListItemButton>
          </Tooltip>
        </List>
      </Box>
    </MuiDrawer>
  );
};

export default Drawer;